const INITIAL_STATE = {
    loadingExtratoCnis: false,
    extratoCnis: null,
    error: null,
    algumExpandido: false,
    erroExtrato: false,
    loadingImpressao: false,
    mensagem: ''
};

export default (state = INITIAL_STATE, action) => {

    switch (action.type){
        
        case 'ECNIS_EXTRATO_SOLICITADO':
            return {loadingExtratoCnis: true, erroExtrato: false, error: false, mensagem: ''};

        case 'ECNIS_EXTRATO_RECEBIDO':
            return {extratoCnis: action.data, error:null, loadingExtratoCnis: false, mensagem: ''};

        case 'ECNIS_ERRO_RECEBIDO':
            return {error: action.data, extratoCnis: null, loadingExtratoCnis: false, erroExtrato:true, mensagem: ''};

        case 'ECNIS_IMPRESSAO_SOLICITADA':
            return {...state, loadingImpressao: true, error: false, mensagem: ''};
        
        case 'ECNIS_IMPRESSAO_RECEBIDA':
            return {...state, esperandoRespostaSolicitacaoDados: false, esperandoRespostaSolicitacaoRelacoes: false, 
                    loadingImpressao: false, mensagem: 'sucesso', error: false};

        case 'ECNIS_ERRO_IMPRESSAO':
            return {...state, loadingImpressao: false, error: true, mensagem: '' };
        
        case 'ECNIS_EXTRATO_NAO_ENCONTRADO':
            return {...state, extratoCnis: [], mensagem: action.payload, loadingExtratoCnis: false, error: false, mensagem: false, loadingImpressao: false};
 
            case 'ECNIS_ERRO_LIMPA':
                return { ...state, loadingImpressao: false, error: false, mensagem: '' };
        default:
            return state;
    }

}